export const removeCandidateFromIds = (candidateId: number) => {
    const candidatesIds = JSON.parse(localStorage.getItem('candidatesIds') || '[]')
    const updatedIds = candidatesIds.filter(({ id }: { id: number }) => id !== candidateId)
    localStorage.setItem('candidatesIds', JSON.stringify(updatedIds))
    return updatedIds
}